module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mh4 mb3"
  }, [_c('div', {
    staticClass: "row mt4 ph4 flex items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 pa3 flex justify-end topics"
  }, [_c('div', {
    staticClass: "flex justify-center items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('pl-button', {
    staticClass: "pl-white b",
    staticStyle: {
      "font-size": "18px",
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('label', {
    class: [_vm.showFile ? 'disable_upload' : ''],
    staticStyle: {
      "cursor": "pointer",
      "display": "block",
      "width": "100%",
      "height": "100%",
      "padding": "5px"
    },
    attrs: {
      "for": "files"
    }
  }, [_vm._v("Upload CSV File")])]), _vm._v(" "), (_vm.showFile) ? _c('div', {
    staticClass: "relative flex justify-center items-center",
    staticStyle: {
      "background-color": "#dfe8f2",
      "margin-top": "5px",
      "width": "170px",
      "max-height": "50px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": "/static/online_roundtable_icons/attach_file_icon.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-xs-9 truncate",
    staticStyle: {
      "color": "#3b24e3",
      "font-size": "18px",
      "font-weight": "400",
      "padding-left": "5px",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "100px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.file_name) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close absolute",
    staticStyle: {
      "color": "#3b24e3",
      "font-size": "14px",
      "text-align": "right",
      "cursor": "pointer",
      "right": "2px",
      "top": "2px"
    },
    on: {
      "click": _vm.discardFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "topic-link primary b",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "14px",
      "text-align": "center"
    },
    attrs: {
      "href": "../../../../static/upload_csv_files/courses.csv",
      "target": "_blank",
      "download": "courses.csv"
    }
  }, [_vm._v("\n          Download Template")])], 1), _vm._v(" "), _c('input', {
    ref: "fileUploader",
    staticStyle: {
      "visibility": "hidden",
      "width": "10px"
    },
    attrs: {
      "id": "files",
      "type": "file",
      "accept": ".csv",
      "disabled": _vm.showFile
    },
    on: {
      "click": _vm.resetFileUploader,
      "change": function($event) {
        return _vm.handleFiles($event)
      }
    }
  }), _vm._v(" "), (_vm.csv_has_errors) ? _c('div', _vm._l((_vm.csv_error_message), function(error) {
    return _c('div', {
      key: error
    }, [_c('p', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(error))])])
  }), 0) : _vm._e()])]), _vm._v(" "), (!_vm.showFile && _vm.handlingFile) ? _c('div', {
    staticClass: "mx-2 middle-xs between-xs mb-7"
  }, [_c('pl-spinner', {
    staticClass: "x3",
    staticStyle: {
      "margin": "auto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mh2 middle-xs between-xs mb-7"
  }, [_c('vue-table', {
    staticClass: "pt3",
    attrs: {
      "tbody-data": _vm.coursesToCheck,
      "headers": _vm.headers,
      "custom-options": _vm.customOptions,
      "style-wrap-vue-table": _vm.styleWrapVueTable,
      "disable-cells": _vm.disableCells,
      "disable-sort-thead": _vm.disableSortThead,
      "loading": _vm.loading,
      "parent-scroll-element": _vm.parentScrollElement,
      "select-position": _vm.selectPosition,
      "submenu-thead": _vm.submenuThead
    },
    on: {
      "tbody-checked-row": _vm.checkedData,
      "tbody-all-checked-row": _vm.checkedAllData,
      "tbody-change-data": _vm.checkErrorsInTable
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.coursesToCheck.length > 0 && _vm.errors_count === 0) ? _c('div', {
    staticClass: "w-100 flex items-center justify-center tc"
  }) : _vm._e(), _vm._v(" "), (_vm.errors_count > 0) ? _c('div', {
    staticClass: "fw6",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n          You have\n          "), _c('label', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.errors_count))]), _vm._v(" errors. Fix them\n          before proceeding.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canImport) ? _c('div', [_c('span', {
    staticClass: "fw6"
  }, [_vm._v("\n            You don't have any errors in your file, you can proceed to add new\n            courses.\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tr pr1 remove_btn",
    class: [
      _vm.coursesToRemove.length === 0 ? 'disable_remove' : 'remove_btn' ]
  }, [_c('span', {
    on: {
      "click": _vm.deleteCourse
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Remove selected")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loader")])]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    staticStyle: {
      "margin": "5px",
      "float": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-9 warning-text"
  }, [_c('div', {
    staticClass: "row col-xs mb1"
  }, [_c('div', {
    staticClass: "red-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("The field should not be empty.")])]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs mb1"
  }, [_c('div', {
    staticClass: "yellow-alert"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("User does not exist in the school")])]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs mb1"
  }, [_c('div', {
    staticClass: "grey-alert"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("Course Name must be between 4 characters and 99 characters")])]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs mb1"
  }, [_c('div', {
    staticClass: "orange-alert"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("Up to 5 co-teachers and 100 students")])]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs"
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2 text-red"
  }, [_vm._v("The email is not valid.")])]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs"
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2 text-orange"
  }, [_vm._v("Duplicated emails on Teacher, Co-teacher or student tabs")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-817577b2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/addCourses/addCoursesUploadCsv.vue
// module id = 2095
// module chunks = 61